import dayjs from "dayjs";

/**
 * Format leave dates for list display as DD-MM-YYYY.
 * - Plain YYYY-MM-DD: use calendar parts (no timezone shift)
 * - ISO datetimes (e.g. 2026-08-10T18:30:00.000Z): use local calendar day
 *   so midnight IST stored as previous-day 18:30Z shows the correct day
 */
export function formatLeaveDateDisplay(value) {
  if (value == null || value === "" || value === "-") return "";
  const s = String(value).trim();
  if (!s) return "";

  // Already DD-MM-YYYY
  if (/^\d{2}-\d{2}-\d{4}$/.test(s)) return s;

  // DD-MMM-YYYY (edit form style)
  if (/^\d{1,2}-[A-Za-z]{3}-\d{4}$/.test(s)) {
    const parsed = dayjs(s, ["DD-MMM-YYYY", "D-MMM-YYYY"], true);
    return parsed.isValid() ? parsed.format("DD-MM-YYYY") : s;
  }

  // Plain date only — never interpret as UTC midnight
  const plain = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (plain) {
    return `${plain[3]}-${plain[2]}-${plain[1]}`;
  }

  // Datetime / ISO — local calendar day (fixes T18:30:00Z → IST next morning)
  const parsed = dayjs(s);
  return parsed.isValid() ? parsed.format("DD-MM-YYYY") : s;
}
